<template>
    <v-container class="invoice-container">
        <div class="invoice-white-bg" id="pdfContent">
            <b-row class="dashed-border pb-3 invoice-header-row">
                <b-col cols="auto" class="pr-1">
                    <b-button
                        size="sm"
                        @click="backButton"
                        class="mr-2 my-0 main-navigation-button"
                        variant="light"
                    >
                        <i class="fa fa-arrow-left" aria-hidden="false"></i>
                    </b-button>
                </b-col>
                <b-col
                    class=" mr-2 box-border info-box d-flex align-items-center mb-2 mb-md-0"
                >
                    <h5 class="order-info invoice-title">TAX INVOICE</h5>
                </b-col>
                <b-col
                    class="mr-2 box-border info-box mb-2 mb-md-0"
                >
                    <p class="order-info">
                        Order Id: {{ invoiceData ? invoiceData.orderId : "" }}
                    </p>
                    <p class="order-info">Order Date: {{ createdDate }}</p>
                </b-col>
                <b-col cols="12" sm="12" md="4" class="mr-2 info-box">
                    <p class="order-info">Payment Mode: COD</p>
                </b-col>
            </b-row>
            <b-row class="dashed-border seller-info-row">
                <b-col cols="12" md="12">
                    <div
                        class="d-flex flex-column align-items-center mt-3 seller-box"
                    >
                        <b-img
                            :src="
                                objData.provider &&
                                objData.provider.organization &&
                                objData.provider.organization.logo
                                    ? objData.provider.organization.logo.url
                                    : ''
                            "
                            width="60"
                            height="60"
                            alt=""
                            class="seller-logo"
                        />
                        <h5 class="order-info mb-2 seller-name">
                            {{
                                objData.provider &&
                                objData.provider.organization
                                    ? objData.provider.organization.name
                                    : ""
                            }}
                        </h5>
                        <p class="order-info seller-address">
                            {{
                                objData.provider &&
                                objData.provider.office &&
                                objData.provider.office.address
                                    ? objData.provider.office.address.city
                                    : ""
                            }}
                        </p>
                        <p class="order-info seller-address">
                            {{
                                objData.provider &&
                                objData.provider.office &&
                                objData.provider.office.address
                                    ? objData.provider.office.address.state
                                    : ""
                            }}
                            -
                            {{
                                objData.provider.office &&
                                objData.provider.office.address
                                    ? objData.provider.office.address.zip
                                    : ""
                            }}
                        </p>
                        <p class="order-info mb-3 seller-phone">
                            Phone:
                            {{
                                objData.provider &&
                                objData.provider.authentication &&
                                objData.provider.authentication.phone
                            }}
                        </p>
                    </div></b-col
                >
            </b-row>
            <div class="invoice-table-wrapper">
                <b-row class="dashed-border invoice-table-header">
                    <b-col cols="12" sm="3" md="3">
                        <h6 class="order-info">Item</h6></b-col
                    >
                    <b-col cols="4" sm="1" md="1">
                        <h6 class="order-info text-center">Qty</h6>
                    </b-col>
                    <b-col cols="4" sm="2" md="2">
                        <h6 class="order-info ml-md-4 text-center">MRP</h6>
                    </b-col>
                    <b-col cols="4" sm="2" md="2">
                        <h6 class="order-info text-center">Base Price</h6>
                    </b-col>
                    <b-col cols="6" sm="2" md="2">
                        <h6 class="order-info text-center">Tax</h6>
                    </b-col>
                    <b-col cols="6" sm="2" md="2">
                        <h6 class="order-info text-center">Amount(₹)</h6>
                    </b-col>
                </b-row>
                <div class="dashed-border">
                    <b-row
                        class="invoice-item-row"
                        v-for="item in invoiceData.ItemsByProvider"
                        :key="item._id"
                    >
                        <b-col cols="12" sm="3" md="3" class="mb-2 mb-sm-0">
                            <p class="order-info invoice-item-name">
                                {{ item.name }}
                            </p>
                        </b-col>
                        <b-col cols="4" sm="1" md="1" class="mb-2 mb-sm-0">
                            <p class="order-info text-center">{{ item.qty }}</p>
                        </b-col>
                        <b-col cols="4" sm="2" md="2" class="mb-2 mb-sm-0">
                            <p class="order-info ml-md-4 text-center">
                                {{ item.unitPrice }}
                            </p>
                        </b-col>
                        <b-col cols="4" sm="2" md="2" class="mb-2 mb-sm-0">
                            <p class="order-info text-center">
                                {{ item.price }}
                            </p>
                        </b-col>
                        <b-col cols="6" sm="2" md="2" class="mb-2 mb-sm-0">
                            <p class="order-info text-center">
                                {{ item.totalTaxes }}
                            </p>
                        </b-col>
                        <b-col cols="6" sm="2" md="2" class="mb-2 mb-sm-0">
                            <p class="order-info text-center">
                                {{ item.finalPrice }}
                            </p>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <b-row class="dashed-border invoice-total-row">
                <b-col cols="12" sm="3" md="3" class="mb-2 mb-md-0">
                    <h6 class="order-info invoice-total-label">Total</h6>
                </b-col>
                <b-col cols="12" sm="9" md="5" class="mb-2 mb-md-0">
                    <h6 class="order-info invoice-total-left">
                        {{
                            Object.keys(
                                invoiceData && invoiceData.ItemsByProvider,
                            ).length
                        }}
                    </h6>
                </b-col>
                <b-col cols="6" sm="6" md="1" class="mb-2 mb-md-0">
                    <h6 class="order-info invoice-total-right">
                        {{ totalTaxAmount.toFixed(2) }}
                    </h6>
                </b-col>
                <b-col cols="6" sm="6" md="3" class="mb-2 mb-md-0">
                    <h6 class="order-info pr-2 invoice-total-center">
                        {{ totalAmount }}
                    </h6>
                </b-col>
            </b-row>
            <!-- <b-row class="dashed-border d-flex justify-content-end">
          <b-col md="1"> <p>CGST</p> </b-col>
          <b-col md="3">
            <p class="text-right pr-2">15</p>
          </b-col>
        </b-row> -->
            <b-row>
                <b-col md="12"
                    ><div
                        class="d-flex flex-column align-items-center mt-4 dashed-border"
                    >
                        <!-- <p>You have saved Rs.200+ on this order + eligible Cash Back</p> -->
                        <p class="order-info">Thank You for shoping with us</p>
                        <p class="order-info">Vist us again</p>
                    </div>
                </b-col>
            </b-row>
        </div>
        <b-row>
            <b-col md="12" class="my-3">
                <div class="text-center">
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="downloadInvoicePdf"
                    >
                        <span class="download-invoice pr-3 pl-3"
                            >Download Invoice</span
                        >
                    </button>
                </div>
            </b-col>
        </b-row>
    </v-container>
</template>

<script>
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { mapState } from "vuex";

export default {
    data() {
        return {};
    },
    computed: {
        ...mapState({
            objData: (state) => state.order.orderDetailsData,
            invoiceData: (state) => state.order.invoiceDetails,
            orderList: (state) => state.order.listOrderAllUsers,
            sellerInfo: (state) => state.partner.partnerDetailsById,
        }),
        createdDate() {
            return moment(this.objData.createdAt).format("DD-MM-YYYY, hh:mm A");
        },
        // async orderInfo() {
        //   let orderObject = this.orderList.find(
        //     (obj) => obj._id === this.$route.params.orderId
        //   );
        //   await this.$store.dispatch(
        //     "partner/fetchPartnerDetailsById",
        //     orderObject.provider
        //   );
        //   return orderObject;
        // },
        // sellerPhone() {
        //   const number = this.sellerInfo?.office?.phone?.map((each) => each.number);
        //   return number[0];
        // },
        totalTaxAmount() {
            let taxes =
                this.invoiceData &&
                this.invoiceData.ItemsByProvider.map((each) => each.totalTaxes);
            let tax = 0;
            for (let i = 0; i < taxes.length; i++) {
                tax = tax + taxes[i];
            }
            return tax;
        },
        totalAmount() {
            let totalBill = this.invoiceData.ItemsByProvider.map(
                (each) => each.finalPrice,
            );
            let total = 0;
            for (let i = 0; i < totalBill.length; i++) {
                total = total + totalBill[i];
            }
            return total;
        },
    },
    methods: {
        backButton() {
            this.$router.push({
                name: "manage-order-details",
                params: { orderId: this.$route.params.orderId },
            });
        },
        downloadInvoicePdf() {
            const pdfDoc = document.querySelector("#pdfContent");
            html2canvas(pdfDoc, {
                allowTaint: true,
                useCORS: true,
                scale: 1,
                width: 1165,
                height: 900,
            }).then((canvas) => {
                var imgData = canvas.toDataURL("image/png");
                var doc = new jsPDF("p");
                doc.addImage(imgData, "PNG", 10, 10, 190, 190);
                doc.save("invoice.pdf");
            });
        },
    },
    async mounted() {
        await this.$store.dispatch(
            "order/fetchInvoiceData",
            this.$route.params.id,
        );
        await this.$store.dispatch(
            "order/getOrderDetails",
            this.$route.params.orderId,
        );
    },
};
</script>

<style scoped>
.dashed-border {
    border-bottom: 2px dashed #e3e3e3;
}
.box-border {
    border-right: 2px dashed #e3e3e3;
}
.info-box p,
h5 {
    margin-bottom: 0px;
}
.seller-info-row {
    padding: 1rem 0;
}

.seller-box {
    padding: 0.5rem 0;
}

.seller-box p {
    margin-bottom: 0.3rem;
}

.seller-logo {
    margin-bottom: 0.5rem;
}

.seller-name {
    font-weight: 600;
    text-align: center;
}

.seller-address,
.seller-phone {
    text-align: center;
    word-break: break-word;
}
.order-info {
    color: black;
    font-size: 16px;
}
.download-invoice {
    color: white;
    font-size: 16px;
}
.showOrder p {
    margin: 10px 0;
}

.invoice-container {
    padding: 1rem;
}

.invoice-white-bg {
    background-color: #ffffff;
    width: 100%;
}

.invoice-total-left {
    left: 5%;
    position: relative;
}

.invoice-total-right {
    left: 85%;
    position: relative;
}

.invoice-total-center {
    left: 37%;
    position: relative;
}

.invoice-header-row {
    align-items: center;
}

.invoice-title {
    margin-bottom: 0;
}

.invoice-table-wrapper {
    overflow-x: auto;
    width: 100%;
}

.invoice-table-header {
    min-width: 600px;
    white-space: nowrap;
}

.invoice-item-row {
    min-width: 600px;
    align-items: center;
}

.invoice-item-name {
    word-break: break-word;
}

.invoice-total-row {
    align-items: center;
}

.invoice-total-label {
    font-weight: 600;
}

.showOrder {
    display: flex;
    width: 100%;
}

@media (max-width: 991.98px) {
    .box-border {
        border-right: none;
        border-bottom: 2px dashed #e3e3e3;
        padding-bottom: 0.5rem;
        margin-bottom: 0.5rem;
    }

    .invoice-header-row .box-border:last-child {
        border-bottom: none;
        margin-bottom: 0;
    }

    .invoice-table-wrapper {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .invoice-table-header,
    .invoice-item-row {
        min-width: 700px;
    }
}

@media (max-width: 767.98px) {
    .invoice-container {
        padding: 0.5rem;
    }

    .invoice-white-bg {
        padding: 1rem !important;
    }

    .invoice-header-row {
        flex-direction: column;
        align-items: flex-start;
    }

    .info-box {
        width: 100%;
    }

    .box-border {
        border-right: none;
        border-bottom: 2px dashed #e3e3e3;
        padding-bottom: 0.75rem;
        margin-bottom: 0.75rem;
    }

    .invoice-header-row .box-border:last-child {
        border-bottom: none;
        margin-bottom: 0;
    }

    .invoice-title {
        font-size: 1.25rem;
    }

    .order-info {
        font-size: 14px;
    }

    .invoice-table-wrapper {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        margin: 0 -1rem;
        padding: 0 1rem;
    }

    .invoice-table-header,
    .invoice-item-row {
        min-width: 600px;
        display: flex;
        flex-wrap: nowrap;
    }

    .invoice-table-header .order-info,
    .invoice-item-row .order-info {
        font-size: 13px;
    }

    .invoice-item-name {
        font-size: 13px;
        word-break: break-word;
        white-space: normal;
    }

    .invoice-total-row {
        flex-direction: column;
        align-items: flex-start;
    }

    .invoice-total-left,
    .invoice-total-right,
    .invoice-total-center {
        left: 0;
        position: static;
        text-align: left;
        width: 100%;
        margin-bottom: 0.5rem;
    }

    .invoice-total-label {
        font-weight: 700;
        margin-bottom: 0.5rem;
    }

    .seller-box {
        padding: 1rem 0;
    }

    .seller-logo {
        width: 50px !important;
        height: 50px !important;
    }

    .seller-name {
        font-size: 1rem;
    }

    .seller-address,
    .seller-phone {
        font-size: 13px;
    }

    .download-invoice {
        font-size: 14px;
        padding: 0.5rem 1rem !important;
    }

    .invoice-white-bg {
        margin: 0 -0.5rem;
    }
}

@media (max-width: 575.98px) {
    .invoice-table-header,
    .invoice-item-row {
        min-width: 550px;
    }

    .invoice-table-header .order-info,
    .invoice-item-row .order-info {
        font-size: 12px;
    }

    .order-info {
        font-size: 13px;
    }
}
</style>
